export default __webpack_public_path__ + "static/media/Transition_V02_Energy_116_Radial_Out_Hit_0000000012.f3bc4440.png";